import { post } from './api';

/**
 * Antes de um pedido à IA sobre o atendimento (resumo, sugestão do chamado): a IA lê os prints e
 * fotos ainda sem leitura. Falhar aqui não impede o pedido: ele segue sem as imagens.
 */
export async function readImages(attendanceId: string): Promise<void> {
  try {
    await post(`/attendances/${attendanceId}/read-images`);
  } catch {
    // segue sem a leitura das imagens
  }
}

/** Serviço e assunto do chamado sugeridos pela IA (lê antes as imagens: muitos clientes abrem só com um print). */
export async function suggestTicket(attendanceId: string, customerId: string | undefined) {
  await readImages(attendanceId);
  return post<{ serviceId: string | null; title: string; system: string | null }>(`/attendances/${attendanceId}/ai-ticket-suggestion`, { customerId });
}
